import { faFolderPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { AddProjectModal } from "./AddProjectModal";
import { useState } from "react";

interface AddProjectProps {}

export function AddProject(props: AddProjectProps) {
    const [isModalVisible, setIsModalVisible] = useState(false);

    return (
        <>
            <Button variant="success" onClick={() => setIsModalVisible(true)}>
                <FontAwesomeIcon icon={faFolderPlus} className="me-1" /> Create New Project
            </Button>

            <AddProjectModal isVisible={isModalVisible} setIsVisible={setIsModalVisible} />
        </>
    );
}
